import type { LocationNumber, PhoneData } from './types';

/** The board's four numbers. The fax is shown and dimmed, not hidden. */
const NUMBERS: LocationNumber[] = [
  {
    e164: '+12105550142',
    display: '(210) 555‑0142',
    role: 'main',
    usedByElva: true,
    what: 'ELVA answers every call on this number, at any hour. Out of hours it uses the after-hours greeting.',
    source: 'account_app',
  },
  {
    e164: '+12105550142',
    display: '(210) 555‑0142',
    role: 'text',
    usedByElva: true,
    what: 'The same number. Patients text the number they already have, and replies come back from it.',
    source: 'account_app',
  },
  {
    e164: '+12105550187',
    display: '(210) 555‑0187',
    role: 'outbound_caller_id',
    usedByElva: true,
    what: 'What a patient sees when ELVA rings them — reminders, recall, a returned call.',
    source: 'account_app',
  },
  {
    e164: '+12105550155',
    display: '(210) 555‑0155',
    role: 'fax',
    usedByElva: false,
    what: 'Not used by ELVA.',
    source: 'account_app',
  },
];

export const PHONE: PhoneData = {
  numbers: NUMBERS,
  texting: { status: 'approved', approvedAt: '14 March' },
  syncedMinutesAgo: 4,
};

/**
 * The caller-ID check (P276). If the outbound caller ID is not the same number
 * as the main line, patients do not recognise it and fewer of them pick up.
 *
 * Derived rather than flagged in the data, so it stays true if the numbers change.
 */
export function callerIdMismatch(numbers: LocationNumber[]): { main?: string; outbound?: string } | undefined {
  const main = numbers.find((n) => n.role === 'main');
  const out = numbers.find((n) => n.role === 'outbound_caller_id');
  if (!main || !out || main.e164 === out.e164) return undefined;
  return { main: main.display, outbound: out.display };
}
